<!-- =========================================================================================
	File Name: Maintenance.vue
	Description: Maintenance Page
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Version: 1.1
	Author: Pixinvent
	Author URL: hhttp://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
	<div class="h-screen flex w-full bg-img">
		<div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto text-center">
			<img src="../../assets/images/pages/maintenance-2.png" alt="graphic-maintenance" class="mx-auto mb-4 responsive">
			<h1 class="mb-6 text-5xl">Under Maintenance!</h1>
			<p class="mb-6">paraphonic unassessable foramination Caulopteris worral Spirophyton encrimson esparcet aggerate chondrule restate whistler shallopy biosystematy area bertram plotting unstarting quarterstaff.</p>
			<vs-button size="large" to="/">Back to Home</vs-button>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
            value1: ''
		}
	}
}
</script>